import { render, staticRenderFns } from "./ModalStartCooperation.vue?vue&type=template&id=648f3f86&scoped=true&"
import script from "./ModalStartCooperation.vue?vue&type=script&lang=js&"
export * from "./ModalStartCooperation.vue?vue&type=script&lang=js&"
import style0 from "./ModalStartCooperation.vue?vue&type=style&index=0&id=648f3f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f3f86",
  null
  
)

export default component.exports